<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Epigraph">
<p class="fmh1" id="epi"><span class="right_1" epub:type="pagebreak" id="page_vii" title="vii"><a href="#/text/9780802156969_Contents#repi">EPIGRAPH</a></span></p>
<p class="extract">Bone of my bone thou art, and from thy state<br/>Mine never shall be parted, weal or woe.</p>
<p class="right1">—John Milton, <i>Paradise Lost</i></p>
<p class="extractl">Do what thy manhood bids thee do<br/>From none but self expect applause;<br/>He noblest lives and noblest dies<br/>Who makes and keeps his self-made laws.</p>
<p class="right1">—Sir Richard Francis Burton</p>
<p class="extractla">Yes, I am proud; I must be proud to see<br/>Men not afraid of God, afraid of me.</p>
<p class="right1">—Alexander Pope, “Epistle to Dr. Arbuthnot”</p>
<p class="extracta">Life is contemptuous of knowledge; it forces it to sit in the anterooms, to wait outside. Passion, energy, lies: these are what life admires.</p>
<p class="right10">—James Salter, <i>Light Years</i></p>
<span class="right_1" epub:type="pagebreak" id="page_viii" title="viii">
</span></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780802156969_Front2.vue?b8af2f36